import { extendTailwindMerge } from "tailwind-merge"

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "xs",
            "sm",
            "md",
            "heading-xs",
            "heading-sm",
            "heading-md",
            "heading-lg",
            "display-sm",
            "display-md",
            "display-lg",
            "display-xl",
          ],
        },
      ],
      z: [
        {
          z: [
            "inset-border",
            "sidebar",
            "fixed-bottom-sheet",
            "takeover-modal-overlay",
            "takeover-modal",
            "overlay",
            "sheet",
            "modal",
            "tooltip",
            "toast",
            "top",
          ],
        },
      ],
      "font-weight": ["font-inherit"],
      rounded: ["rounded-inherit", "rounded-initial"],
    },
  },

  override: {
    conflictingClassGroups: {
      "font-size": [],
    },
    conflictingClassGroupModifiers: {
      "font-size": [],
    },
  },
})
